/** Local upload references are single raster filenames, never arbitrary filesystem paths. */
export const REFERENCE_IMAGE_ACCEPT = 'image/jpeg,image/png,image/gif,image/webp,image/avif,.jpg,.jpeg,.png,.gif,.webp,.avif';
export function isUploadedImagePath(value: string): boolean {
  return /^\/uploads\/[a-zA-Z0-9_-]+\.(?:jpe?g|png|gif|webp)$/i.test(value);
}
export function isImageReference(value: unknown): value is string {
  return typeof value === 'string' && (/^https?:\/\/[^\s\]]+$/i.test(value) || isUploadedImagePath(value));
}
export function attachedImageReferences(message: string): string[] {
  return Array.from(new Set(Array.from(message.matchAll(/\[(?:Attached|Reference) image(?: to clone)?:\s*([^\]\s]+)\]/gi)).map(match => match[1]).filter(isImageReference)));
}

/** A singular clone uses the first attached ad; selected ads keep uploads as supporting references. */
export function uploadedCloneSourceUrls(message: string, attached: string[], selected: string[]): string[] {
  if (selected.length) return [];
  const text = message.replace(/\[(?:Attached|Reference) image[^\]]*\]/gi, '');
  const pluralObject = /\b(?:clone|copy|recreate|adapt|duplicate)\s+(?:(?:these|those)\b|(?:all|each)\s+(?:of\s+)?(?:(?:the|these|those|attached|uploaded|reference)\s+)*(?:ads?|images?|creatives?|references?|them)\b)/i.test(text);
  const pluralCopies = /\b(?:make|create|generate)\s+(?:\d{1,3}\s+)?(?:copies|clones)\s+of\s+(?:these|those)(?:\s+(?:ads|images|creatives)\b|(?=\s*(?:$|[.!?,;:]|(?:using|with|for|but)\b)))/i.test(text);
  return pluralObject || pluralCopies ? attached : attached.slice(0,1);
}
